/**
 * Classe usata per la gestione della chat ai all'interno della pagina info apartment dell'ospite
 */

class ApartmentInfo {
  constructor(api_url, apt_id) {
    this.api_url = api_url
    this.payload = {
      session_id: null,
      text: null,
      lang: null,
      apt_id: apt_id,
      category: "CHAT_BOT_APT"
    }
    this.activeStar = null
  }

  init() {
    this.initEvents()
  }

  async sendMessage() {

    const textarea = document.querySelector('#textarea')
    const message = textarea.value.trim()
    if (message) {
      this.renderMessage('user', message)
      const aiChatContainer = document.getElementById('ai-chat-container')
      if (!aiChatContainer.classList.contains('open')) {
        aiChatContainer.classList.add('open')
      }
      this.renderLoading()
      this.scrollContainer()
      textarea.value = ''
      this.payload.text = message
      this.payload.lang = (navigator.language || 'en').split('-')[0].toLowerCase();
      try {
        const response = await fetch(`${this.api_url}/ui/v1/agent_ai/chat`, {
          method: 'POST',
          body: JSON.stringify(this.payload),
          headers: {
            'Content-Type': 'application/json'
          },
        })
        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.error)
        } else {
          this.payload.session_id = data.session_id
          document.querySelector('.rating').classList.add('show')
          this.removeLoading()
          this.renderMessage('agent', data.reply)
        }
      } catch (error) {
        this.removeLoading()
        this.renderAlert('inline', error.message, 0)
      }
    } else {
      this.removeLoading()
      this.renderAlert('global', I18n.t('apartments_page.apartment_page.ai_text_required'), 3000)
    }
  }

  async sendRating (index) {
    let rating = index + 1
    if (rating) {
      try {
        const response = await fetch(`${this.api_url}/ui/v1/agent_ai/evaluate_chat`, {
          method: 'POST',
          body: JSON.stringify({session_id: this.payload.session_id, vote: rating}),
          headers: {
            'Content-Type': 'application/json'
          },
        })
        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.error)
        } else {
          this.renderAlert('global', data.message, 3000, 'success')
        }
      } catch (error) {
        this.removeLoading()
        this.renderAlert('global', error.message, 0)
      }
    }
  }

  resetChat() {
    document.querySelector('#chat-container').innerHTML = ''
    document.querySelector('#textarea').value = ''
    document.querySelectorAll('.fa-star').forEach(s => s.classList.remove('active'))
    document.querySelector('.rating').classList.remove('show')
    const aiChatContainer = document.getElementById('ai-chat-container')
    if (aiChatContainer.classList.contains('open')) {
      aiChatContainer.classList.remove('open')
    }
    this.payload = {
      session_id: null,
      text: null,
      lang: null,
    }
    this.activeStar = null
  }

  loading() {
    const div = document.createElement('div')
    div.classList.add('loading-ai')
    div.id = 'loading-ai'
    div.innerHTML='<i class="fa-duotone fa-solid fa-loader"></i>'
    return div
  }

  alert(text, className) {
    const div = document.createElement('div')
    div.classList.add(className)
    div.id = 'alert-ai'
    div.innerHTML = text
    return div
  }

  message(type, text) {
    const div = document.createElement('div')
    div.classList.add(type)
    div.style.whiteSpace = "normal"
    div.innerHTML = text
    return div
  }

  removeLoading() {
    if (document.querySelector('#loading-ai')) {
      document.querySelector('#loading-ai').remove()
    }
  }

  // type: 'global' | 'inline'
  renderAlert(type, text, time, className='error'){
    if (type === 'global') {
      document.querySelector('#main-container').prepend(this.alert(text, className))
      if (time) {
        setTimeout(() => {
          document.querySelector('#alert-ai').remove()
        }, time)
      }
    } else {
      this.renderMessage('error-inline', text)
    }

  }

  // type: 'user' | 'agent' | 'error-inline'
  renderMessage(type, text) {
    document.querySelector('#chat-container').append(this.message(type, text))
  }
  renderLoading() {
    document.querySelector('#chat-container').append(this.loading())
  }

  scrollContainer() {
    document.querySelector('#chat-container').scrollTo({
      top:  document.querySelector('#chat-container').scrollHeight,
    })
  }

  addEventClass(elements, index, className) {
    elements.forEach((s, i) => {
      if (i <= index) {
        s.classList.add(className)
      } else {
        s.classList.remove(className)
      }
    })
  }

  initEvents() {
    document.querySelector('#send').addEventListener('click', () => this.sendMessage())
    document.querySelector('#reset').addEventListener('click', () => this.resetChat())
    document.querySelector('#textarea').addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault()
        this.sendMessage()
      }
    })
    const stars = document.querySelectorAll('.fa-star')

    // Logica colore stars suggerita da Kiro
    stars.forEach((star, index) => {
      star.addEventListener('mouseenter', () => {
        stars.forEach(s => s.classList.remove('active'))
        this.addEventClass(stars, index, 'hover')
      })
      star.addEventListener('click', () => {
        this.activeStar = index
        this.addEventClass(stars, index, 'active')
        this.sendRating(index)
      })
    })
    document.querySelector('.rating').addEventListener('mouseleave', () => {
      stars.forEach(s => s.classList.remove('hover'))
      if (this.activeStar !== null) {
        this.addEventClass(stars, this.activeStar, 'active')
      }
    })
  }

}

export default ApartmentInfo
